import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserSharedModule } from '../user-shared';
import { CoachRoutingModule } from './coach-routing.module';
import { CoachListComponent } from './coach-list/coach-list.component';

@NgModule({
  imports: [
    CommonModule,
    UserSharedModule,
    CoachRoutingModule
  ],
  declarations: [
    CoachListComponent
  ]
})
export class CoachModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/coach/coach.module.ts